import React, { useEffect, useState } from 'react';
export function ProgressBar() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scroll = `${totalScroll / windowHeight * 100}%`;
      setProgress(totalScroll / windowHeight * 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="fixed top-0 left-0 h-[3px] bg-gradient-to-r from-sage to-teal z-[100] transition-all duration-150 ease-out" style={{
    width: `${progress}%`
  }} data-id="element-226" />;
}